import { render, staticRenderFns } from "./WorkRelationsTableForm.vue?vue&type=template&id=0b32e642&scoped=true&"
import script from "./WorkRelationsTableForm.vue?vue&type=script&lang=ts&"
export * from "./WorkRelationsTableForm.vue?vue&type=script&lang=ts&"
import style0 from "./WorkRelationsTableForm.vue?vue&type=style&index=0&id=0b32e642&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b32e642",
  null
  
)

export default component.exports